import actions from './actions'
import mutations from './mutation'

const state = {
  oracle_list: [],
  oracle_paging: {
    offset: 0,
    limit: 10,
    total: 0,
    totalPages: 0
  }
}

export default {
  state,
  actions,
  mutations
}
